<template>
  <div class="rulesMain" ref="container">
    <SearchForm v-model="keyWord" placeholder="请输入规则"></SearchForm>
    <isEmpty v-if="ruleList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          暂时没有规则数据
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">
        全部规则
        <span>
          {{ total }}
        </span>
      </div>
      <mu-load-more
          @refresh="refresh"
          :refreshing="refreshing"
          :loaded-all="loaded_all"
          :loading="loading"
          @load="load"
      >
        <div class="list-item"
             v-for="(item, index) in ruleList"
             :key="`list-item_${index}`">
          <div class="header-info">
            <div class="title text-overflow">
              {{ item.changeName }}
            </div>
            <!--            <div class="is-default">默认</div>-->
          </div>
          <div class="body">
            <div class="count">
              应用设备：{{ item.pileCount || 0 }}台
            </div>
          </div>
          <div class="options-box">
            <div class="options-item"
                 @click="editrule(item.id, item.changeName, item.createtime, userId)">
              编辑
            </div>
            <div class="options-item" @click="handleDialogVisible(true,'copy',item)">复制</div>
            <div class="options-item"
                 v-if="item.pileCount == 0"
                 @click="handleDialogVisible(true,'delete',item)">删除
            </div>
          </div>
        </div>
      </mu-load-more>
    </div>
    <AddOperate @click="addRuleL"></AddOperate>
    <van-dialog
        @close="handleDialogVisible(false)"
        v-model="visible"
        :show-cancel-button="false"
        :show-confirm-button="false"
        width="6.8918rem"
        class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title" v-if="visibleType == 'delete'">删除</div>
        <div class="title" v-else-if="visibleType == 'copy'">复制规则</div>
        <div class="content-box">
          <div class="desc" v-if="visibleType == 'delete'">
            您是否确定要删除该计费规则？
          </div>
          <el-input v-model="ruleName" maxlength="20"
                    show-word-limit v-else-if="visibleType == 'copy'" placeholder="请输入规则名称"></el-input>
          <div class="confirm" @click="confirm()">确认</div>
          <div class="text" @click="handleDialogVisible(false)">我再想想</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {getRuleList, copyRule, deleteRule} from "@/api/newApi";
import {Toast} from "vant";
import AddOperate from "@/components/add-operate/index.vue";

export default {
  components: {AddOperate},
  data() {
    return {
      visible: false,
      visibleType: 'copy',
      ruleName: '',
      visibleItem: null, // 弹框选中数据
      ruleList: [],
      userId: localStorage.getItem("userId"),
      nolist: true,
      loading: false,
      refreshing: false,
      num: 1,
      loaded_all: false,
      pages: 0,
      total: 0,
      keyWord: "",
    };
  },
  watch: {
    keyWord: function (v) {
      this.pages = 1;
      this.ruleList = [];
      this.getList({pageNo: this.num, pageSize: 10, deviceType: 4});
    },
  },
  mounted() {
    this.getList({pageNo: this.num, pageSize: 10, deviceType: 4});
  },
  methods: {
    handleDialogVisible(visible, type, item) {
      if (visible) {
        this.visibleType = type;
        this.visibleItem = item;
      } else {
        this.ruleName = ""
      }
      this.visible = visible;
    },
    confirm() {
      let actionObject = {
        'delete': {
          action: deleteRule,
          form: {id: this.visibleItem.id},
          successMsg: "删除成功",
          rules: () => true
        },
        'copy': {
          action: copyRule,
          form: {
            changeName: this.ruleName,
            id: this.visibleItem.id,
          },
          successMsg: "复制规则成功",
          rules: () => {
            if (this.ruleName) {
              return true
            } else {
              Toast("请输入规则名称")
              return false
            }
          }
        },
      }[this.visibleType]
      if (actionObject.rules()) {
        actionObject.action(actionObject.form).then(res => {
          if (res.message.code == 0) {
            Toast(actionObject.successMsg);
            this.num = 1;
            this.ruleList = [];
            this.getList({pageNo: this.num, pageSize: 10, deviceType: 4});
          } else {
            Toast(res.message.message);
          }
          this.handleDialogVisible(false)
        })
      }
    },
    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.num = 1;
        this.ruleList = [];
        this.getList({pageNo: this.num, pageSize: 10, deviceType: 4});
      }, 1000);
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          this.getList({
            pageNo: this.num,
            pageSize: 10,
            deviceType: 4,
          });
        }
      }, 2000);
    },
    addRuleL() {
      this.$router.push({
        path: `/admin/editrule/`,
        query: {
          userId: this.userId,
        },
      });
    },
    getList(params) {
      getRuleList({...params, ruleNm: this.keyWord}).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            this.total = res.data.total;
            this.pages = res.data.pages;
            res.data.records.forEach((item) => {
              this.ruleList.push(item);
            });
            this.nolist = false;
            if (res.data.pages == this.num) {
              Toast("已加载全部数据");
              this.loaded_all = true;
            }
          }
        } else {
          this.ruleList = [];
          Toast("暂无数据");
        }
      });
    },
    copyrule(obj) {
      console.log(obj);
      var that = this;
      this.$dialog({
        id: "my-dialog",
        title: "请输入规则名称",
        content: `<input type="text" id="textbox_id" style="background: transparent;border:1px solid #6C7EC1;padding:5px;border-radius:10px"/>`,
        onOkBtn() {
          let value = document.getElementById("textbox_id").value;
          if (value) {
            copyRule({
              changeName: value,
              id: obj.id,
            }).then((res) => {
              if (res.message.code == 0) {
                Toast("复制规则成功");
                that.num = 1;
                that.ruleList = [];
                that.getList({pageNo: that.num, pageSize: 10, deviceType: 4});
              } else {
                Toast(res.message.message);
              }
            });
          } else {
            Toast("取消复制规则");
          }
          this.close();
        },
      });
    },
    editrule(id, changeName, createtime, userId) {
      this.$router.push({
        path: `/admin/editrule/`,
        query: {
          id: id,
          changeName: changeName,
          createtime: createtime,
          userId: userId,
        },
      });
    },
    deleterule(id, count) {
      var that = this;
      if (count != 0) {
        return;
      }
      this.$dialog({
        id: "my-dialog2",
        title: "确认删除？",
        onOkBtn() {
          deleteRule({id: id}).then((res) => {
            if (res.message.code == 0) {
              Toast("删除成功");
              that.num = 1;
              that.ruleList = [];
              that.getList({pageNo: that.num, pageSize: 10, deviceType: 4});
            } else {
              Toast(res.message.message);
            }
          });
          this.close();
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.rulesMain {
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;


  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      color: #666666;
      font-size: $fontSize_14;
      position: relative;
    }

    span {
      color: #3D3D3D;
      margin-left: 0.1rem;
      font-weight: bold;
    }

    .list-item {
      margin-bottom: 0.3rem;
      border-radius: $borderRadius;
      background-color: white;
      padding: $divPadding;

      .header-info {
        display: flex;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid #ECECEC;

        .title {
          color: #444444;
          font-size: $fontSize_14;
          max-width: 80%;
          font-weight: bold;
        }

        .is-default {
          padding: 0.1rem 0.2rem;
          font-size: 0.2702rem;
          border-radius: 0.054rem;
          background-color: #E8F3FF;
          color: #165DFF;
          margin-left: 0.3rem;
        }
      }

      .body {
        .count {
          padding: 0.3rem 0;
          padding-bottom: 0.6rem;
          color: #666666;
          font-size: $fontSize_12;
        }
      }

      .options-box {
        display: flex;
        justify-content: flex-end;

        .options-item {
          color: #8697D9;
          border: 1px solid #8697D9;
          padding: 0.1rem 0.7rem;
          margin-right: 0.3rem;
          border-radius: 1rem;
          font-size: $fontSize_12;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .dialog-content {
    .title {
      text-align: center;
      font-size: 0.3783rem;
      color: #3D3D3D;
      font-weight: bold;
      padding: 0.3rem;
    }

    .content-box {
      text-align: center;

      ::v-deep .el-input {
        padding: 0 0.5rem;

        .el-input__inner {
          background-color: #F5F5F5;
          width: calc(100% - 0.1rem);
          text-align: center;
          padding-right: 1.5rem;
        }
        .el-input__suffix{
          right: 0.7rem;
          .el-input__count{
            font-size: $fontSize_12;
            .el-input__count-inner{
              background-color: transparent;
            }
          }
        }

      }

      .desc {
        color: #666666;
        font-size: 0.3243rem;
      }

      .confirm {
        width: 5.5135rem;
        border-radius: 1rem;
        padding: 0.2rem;
        margin: 0 auto;
        background-color: #4664DF;
        color: white;
        font-size: 0.3243rem;
        margin-top: 0.6rem;
      }

      .text {
        padding: 0.3rem;
        font-size: 0.3243rem;
        color: #888888;
      }
    }
  }
}
</style>
